export const DEFAULT_MAX_DELAY_BETWEEN_STROKES_MS = 1000;
